require('particles.js');

particlesJS.load('particles-js', '/particlesjs-config.json', () => {});
